export const SUBFLOW_TYPES = {
    predefined: 'Predefined',
    value: 'Value',
};
